export default __webpack_public_path__ + "static/media/594.bd1946e2.jpg";